<template>
    <div id="app">
        <Header
            :routes="[{ name: 'Resellers Dashboard', label: $translate.text('nav.dashboard') }, { name: 'Resellers Profiles', label: $translate.text('nav.profiles') }]"
            :profileRoutes="[{ name: 'Account', label: $translate.text('auth.my_account') }, { name: 'Resellers Summary', label: $translate.text('resellers.summary') }, { name: 'Logout', label: $translate.text('auth.logout') }]"
            name="resellers"
        />
        <div class="content">
            <router-view/>
        </div>
        <Footer
            :routes="[
                { name: 'General About Us', label: $translate.text('nav.footer.about') },
                { name: 'General Conditions', label: $translate.text('nav.footer.conditions') },
                { name: 'General faq', label: $translate.text('nav.footer.help') },
                { name: 'General Contact Us', label: $translate.text('nav.footer.contact') }
            ]"
            name="resellers"
            :showLoggedIn="true"
        />
    </div>
</template>
<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Resellers',

    components: {
        Header,
        Footer,
    },
};
</script>
<style lang="scss" scoped>
    .content {
        min-height: 100%;
        margin-bottom: -50px;
    }
</style>
